<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div class="detail">
            <div class="fz_30 bh bstart">
                <div class="b1">订单编号</div>
                {{info.orderCode}}
            </div>
            <div class="fz_30 bh bstart">
                <div class="b1">订单金额</div>
                <div class="ico-maintenance bg-contain"></div>
                <span class="c_red">{{info.orderPayment}}</span>
            </div>
        </div>
        <div class="line"></div>
        <div class="btns-container">
            <!-- <van-button
                class="btn btn-next border-bottom"
                v-if="isWeiXinPay"
                v-on:click.native="onPayClick(true)"
            >
                <div class="bh bstart">
                    <div class="btn-ico-el ico-weixin"></div>
                    <div class="fz_30 b1 tl">微信支付</div>
                    <div class="ico-next bg-contain"></div>
                </div>
            </van-button> -->
            <van-button
                :disabled="isPointsDisabled"
                v-on:click.native="onPayClick(false)"
                class="btn btn-next border-bottom"
            >
                <div class="bh bstart">
                    <div class="btn-ico-el ico-points"></div>
                    <div class="fz_30 b1 tl" :class="isPointsDisabled?'c_999':''">
                        余额支付
                        <span class="c_999">
                            (剩余车主币
                            <span
                                :class="isPointsDisabled?'c_999':'c_warning'"
                            >{{unusedPoints}}</span>)
                        </span>
                    </div>
                    <div class="ico-next bg-contain"></div>
                </div>
            </van-button>
        </div>
    </div>
</template>
<script>
import { weixinPay, integralPay } from "@/api/cart";
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { mixinBreak } from "@/mixin/break";
// import { wxPay } from "@/utils/bridge";
export default {
    mixins: [routeCache, user, mixinBreak],
    name: "CartOrderPay",
    data() {
        return {
            // 是否支持微信支付
            isWeiXinPay: true,
            info: {},
            // 是否跳转指定支付成功页面
            orderEndPage: ''
        };
    },
    computed: {
        unusedPoints() {
            return this.$store.getters.unusedPoints;
        },
        // 是否禁用积分支付
        isPointsDisabled() {
            return this.unusedPoints < this.info.orderPayment;
        }
    },
    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            me.info = me.getCache();
            me.isWeiXinPay = !params.isDisabledWeiXin;
        },
        onPayClick: function(isWeiXin) {
            if (isWeiXin) {
                this.toast.fail('因系统升级暂无法使用');
            } else {
                const me = this
                me.dialog
                    .confirm({
                        title: "温馨提示",
                        message: "是否确认支付？"
                    })
                    .then(() => {
                        // 普通支付
                        me.orderEnd(isWeiXin);
                    });
            }
            // const me = this
            // const info = me.info;
            // me.dialog
            //     .confirm({
            //         title: "温馨提示",
            //         message: "是否确认支付？"
            //     })
            //     .then(() => {
            //         if (isWeiXin) {
            //             wxPay(info.orderCode).then(res => {
            //                 me.orderEnd(isWeiXin);
            //             });
            //         } else {
            //             // 普通支付
            //             me.orderEnd(isWeiXin);
            //         }
            //     });
        },
        orderEnd: function(isWeiXin) {
            const me = this,
                // 支付模式不同，提交接口不同
                pay = isWeiXin ? weixinPay : integralPay;
            pay(me.info.orderCode).then(res => {
                if (res.data.success) {
                    // 获取页面参数
                    const cachaParams = me.getCache(),
                        // 订单类型
                        orderType = cachaParams.orderType;
                    if (orderType == 3) {
                        // 违章查询
                        me.delayDo(() => {
                            me.getBreakList(cachaParams.params, true);
                        });
                    } else if (orderType == 5) {
                        // 驾照查分
                        me.delayDo(() => {
                            me.getDriving(cachaParams.id, true);
                            // 返回上一页
                            me.backGo();
                        });
                    } else {
                        // 标识需要更新用户订单列表数据
                        me.$store.state.cart.isUpdateUserOrder = true;
                        me.$store.dispatch("cart/orderCount", true);
                        if (!res.data.orderId) {
                            me.dialog.alert({
                                title: "提示",
                                message: "后端未返回订单id"
                            });
                        } else {
                            // 存储订单id，避免支付结果中找不到订单id
                            me.$store.state.cart.orderId = res.data.orderId;
                            // 正常支付成功
                            me.replaceGo(
                                !this.orderEndPage ? "CartOrderConsequence" : this.orderEndPage,
                                Object.assign(res.data, {
                                    isWeiXin: isWeiXin
                                })
                            );
                        }
                    }
                    // 更新积分信息
                    me.$store.dispatch("userInfo", true);
                }
            });
        },
        delayDo(fun) {
            // 延迟执行，防止遮罩不显示
            this.toast.loading("查询中...");
            // 支付后延迟两秒请求数据，避免服务端查询状态不正确
            setTimeout(() => {
                // 清除遮罩，避免计数器出错
                this.toast.clear();
                fun();
            }, 2000);
        }
    },
    mounted() {
        this.orderEndPage = this.$route.query.orderEndPage ? this.$route.query.orderEndPage : ''
        // console.log(this.$route.query)
    }
};
</script>
<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
    .detail {
        padding: 60px 30px;
        background: #fff;
        .ico-maintenance {
            width: 28px;
            height: 28px;
            margin-right: 8px;
        }
    }

    .btns-container {
        padding: 20px 0;
        background: #fff;
        .btn-next {
            width: 100%;
            .btn-ico-el {
                margin-right: 12px;
            }
            &.border-bottom:after {
                width: calc(100% - 60px);
                left: 30px;
                border-color: #dcdcdc;
            }
            &:last-child {
                &.border-bottom:after {
                    border: 0;
                }
            }
        }
    }
}
</style>
